import { inject } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { WorkspaceConfigService } from '../../../shared/misc-services/workspace-config.service';
import {
  finalizeSamplePath,
  markTaskAsReviewedPath,
} from '../../../shared/misc-utilities/sampling-portal-paths';
import { SampleTask } from '../../../team-apis/otterdam/sample-task';
import { AbstractResource } from '../../http/abstract-resource';
import { SamplingWorkspaceStore } from '../state/sampling-workspace-store';

export class TaskReviewFinalizeResourceService extends AbstractResource {
  private workspaceConfigService = inject(WorkspaceConfigService);
  private store = inject(SamplingWorkspaceStore);

  async markAsReviewed(sampleTaskId: number) {
    const { projectId, sampleId } = this.workspaceConfigService;

    const updateSampleTask = await lastValueFrom(
      this.request$<SampleTask>(
        'POST',
        markTaskAsReviewedPath(projectId, sampleId!, sampleTaskId),
        {
          tokenScope: 'access_token',
          customErrorMessage: 'Failed to mark task as reviewed.',
        },
      ),
    );

    this.store('sampleTasks').setUsing((sampleTasks) =>
      sampleTasks.map((sampleTask) =>
        sampleTask.id === sampleTaskId
          ? { ...sampleTask, reviewed: updateSampleTask.reviewed }
          : sampleTask,
      ),
    );
  }

  async finalizeSample() {
    const { projectId, sampleId } = this.workspaceConfigService;

    await lastValueFrom(
      this.request$('POST', finalizeSamplePath(projectId, sampleId!), {
        tokenScope: 'access_token',
        customErrorMessage: 'Failed to finalize sample.',
      }),
    );

    this.store('sample')('status').set('finalized');
  }
}
